import {
  ExtendedUser,
  UsersRolesInformation,
  UserRolesInformationDTO,
  UserAccess,
  SingleUsersRolesInformation,
  UserIdentityInfoWithStatus,
} from './types';

export enum UsersActionTypes {
  FETCH_USERS_SUCCESS = '@@users/FETCH_USERS',
  FETCH_USERS_ERROR = '@@users/FETCH_USERS_ERROR',

  POST_USERS_SUCCESS = '@@users/POST_USERS_SUCCESS',
  POST_USERS_ERROR = '@@users/POST_USERS_ERROR',

  PUT_USER_SUCCESS = '@@users/PUT_USER_SUCCESS',
  PUT_USER_ERROR = '@@users/PUT_USER_ERROR',

  PATCH_USER_SUCCESS = '@@users/PATCH_USER_SUCCESS',
  PATCH_USER_ERROR = '@@users/PATCH_USER_ERROR',

  DELETE_USER_SUCCESS = '@@users/DELETE_USER_SUCCESS',
  DELETE_USER_ERROR = '@@users/DELETE_USER_ERROR',

  POST_USERS_ROLES_SUCCESS = '@@users/POST_USERS_ROLES_SUCCESS',
  POST_USERS_ROLES_ERROR = '@@users/POST_USERS_ROLES_ERROR',

  POST_SINGLE_USER_ROLE_SUCCESS = '@@users/POST_SINGLE_USER_ROLE_SUCCESS',
  POST_SINGLE_USER_ROLE_ERROR = '@@users/POST_SINGLE_USER_ROLE_ERROR',

  POST_IMX_DATA_SUCCESS = '@@users/POST_IMX_DATA_SUCCESS',
  POST_IMX_DATA_ERROR = '@@users/POST_IMX_DATA_ERROR',

  POST_MAP_APPLICATIONS_SUCCESS = '@@users/POST_MAP_APPLICATIONS_SUCCESS',
  POST_MAP_APPLICATIONS_ERROR = '@@users/POST_MAP_APPLICATIONS_ERROR',

  CLEAR_USERS_ERROR = '@@users/CLEAR_USERS_ERROR',

  CLEAR_WAITING_FOR_USERS = '@@users/CLEAR_WAITING_FOR_USERS',

  CLEAR_USER_ROLE_INFORMATION = '@@users/CLEAR_USER_ROLE_INFORMATION',
  GET_USER_ROLE_INFORMATION = '@@users/GET_USER_ROLE_INFORMATION',
  GET_USER_ROLE_INFORMATION_ERROR = '@@users/GET_USER_ROLE_INFORMATION_ERROR',

  POST_RESET_PASSWORD_ERROR = '@@users/POST_RESEt_PASSWORD_ERRORS',

  FETCH_PORTALS_REQUEST = '@@users/FETCH_PORTALS',
  FETCH_PORTALS_SUCCESS = '@@users/FETCH_PORTALS_SUCCESS',
  FETCH_PORTALS_ERROR = '@@users/FETCH_PORTALS_ERROR',

  GET_USER_IDENTITY_SUCCESS = '@@users/GET_USER_IDENTITY_SUCCESS',
  GET_USER_IDENTITY_ERROR = '@@users/GET_USER_IDENTITY_ERROR',
  CLEAR_USER_IDENTITY = '@@users/CLEAR_USER_IDENTITY',

  POST_DISTRIBUTORS_SUCCESS = '@@users/POST_DISTRIBUTORS_SUCCESS',
  POST_DISTRIBUTORS_ERROR = '@@users/POST_DISTRIBUTORS_ERROR',
}

interface IFetchUsersSuccess {
  type: typeof UsersActionTypes.FETCH_USERS_SUCCESS;
  users: ExtendedUser[];
}

interface IFetchUsersError {
  type: typeof UsersActionTypes.FETCH_USERS_ERROR;
  status: number;
}

interface IPostUsersSuccess {
  type: typeof UsersActionTypes.POST_USERS_SUCCESS;
  users: ExtendedUser[];
  status: number;
}

interface IPostUsersError {
  type: typeof UsersActionTypes.POST_USERS_ERROR;
  status: number;
  message: string;
}

interface IPutUserSuccess {
  type: typeof UsersActionTypes.PUT_USER_SUCCESS;
  user: ExtendedUser;
}

interface IPutUserError {
  type: typeof UsersActionTypes.PUT_USER_ERROR;
  status: number;
  message: string;
}

interface IPatchUserSuccess {
  type: typeof UsersActionTypes.PATCH_USER_SUCCESS;
  user: ExtendedUser;
}

interface IPatchUserError {
  type: typeof UsersActionTypes.PATCH_USER_ERROR;
  status: number;
  message: string;
}

interface IDeleteUserSuccess {
  type: typeof UsersActionTypes.DELETE_USER_SUCCESS;
  userName: string;
}

interface IDeleteUserError {
  type: typeof UsersActionTypes.DELETE_USER_ERROR;
  status: number;
  message: string;
}

interface IPostUsersRolesSuccess {
  type: typeof UsersActionTypes.POST_USERS_ROLES_SUCCESS;
  userRolesInformation: UsersRolesInformation;
}

interface IPostUsersRolesError {
  type: typeof UsersActionTypes.POST_USERS_ROLES_ERROR;
  status: number;
  message: string;
}

interface IPostSingleUserRoleSuccess {
  type: typeof UsersActionTypes.POST_SINGLE_USER_ROLE_SUCCESS;
  singleUsersRolesInformation: SingleUsersRolesInformation;
}

interface IPostSingleUserRoleError {
  type: typeof UsersActionTypes.POST_SINGLE_USER_ROLE_ERROR;
  status: number;
  message: string;
}

interface IPostIMXDataSuccess {
  type: typeof UsersActionTypes.POST_IMX_DATA_SUCCESS;
  status: number;
}

interface IPostIMXDataError {
  type: typeof UsersActionTypes.POST_IMX_DATA_ERROR;
  message: string;
}

interface IPostIMapApplicationsSuccess {
  type: typeof UsersActionTypes.POST_MAP_APPLICATIONS_SUCCESS;
  status: number;
}

interface IPostIMapApplicationsError {
  type: typeof UsersActionTypes.POST_MAP_APPLICATIONS_ERROR;
  message: string;
}

interface IClearUsersError {
  type: typeof UsersActionTypes.CLEAR_USERS_ERROR;
}

interface IClearWaitingForUsers {
  type: typeof UsersActionTypes.CLEAR_WAITING_FOR_USERS;
  userNames: string[];
}

interface IClearUserRoleInformation {
  type: typeof UsersActionTypes.CLEAR_USER_ROLE_INFORMATION;
}

interface IGetUserRoleInformation {
  type: typeof UsersActionTypes.GET_USER_ROLE_INFORMATION;
  user: UserRolesInformationDTO;
}
interface IGetUserRoleInformationError {
  type: typeof UsersActionTypes.GET_USER_ROLE_INFORMATION_ERROR;
  status: number;
}

interface IPostResetPasswordError {
  type: typeof UsersActionTypes.POST_RESET_PASSWORD_ERROR;
  status: number;
  message: string;
}

interface IGetPortals {
  type: typeof UsersActionTypes.FETCH_PORTALS_REQUEST;
  isFetching: boolean;
}

interface IGetPortalsSuccess {
  isFetching: boolean;
  type: typeof UsersActionTypes.FETCH_PORTALS_SUCCESS;
  userAccess: UserAccess;
}

interface IGetPortalsError {
  isFetching: boolean;
  type: typeof UsersActionTypes.FETCH_PORTALS_ERROR;
}

interface IPostDistributorSuccess {
  status: number;
  type: typeof UsersActionTypes.POST_DISTRIBUTORS_SUCCESS;
}
interface IPostDistributorError {
  message: string;
  type: typeof UsersActionTypes.POST_DISTRIBUTORS_ERROR;
}

interface IGetUserIdentitySuccess {
  type: typeof UsersActionTypes.GET_USER_IDENTITY_SUCCESS;
  userIdentityInfo: UserIdentityInfoWithStatus;
}

interface IGetUserIdentityError {
  type: typeof UsersActionTypes.GET_USER_IDENTITY_ERROR;
  userIdentityInfo: UserIdentityInfoWithStatus;
  status: number;
}

interface IClearUserIdentity {
  type: typeof UsersActionTypes.CLEAR_USER_IDENTITY;
}

export type UsersActions =
  | IFetchUsersSuccess
  | IFetchUsersError
  | IPostUsersSuccess
  | IPostUsersError
  | IPostSingleUserRoleSuccess
  | IPostSingleUserRoleError
  | IPutUserSuccess
  | IPutUserError
  | IPatchUserSuccess
  | IPatchUserError
  | IDeleteUserSuccess
  | IDeleteUserError
  | IPostUsersRolesSuccess
  | IPostUsersRolesError
  | IPostIMapApplicationsSuccess
  | IPostIMapApplicationsError
  | IPostIMXDataSuccess
  | IPostIMXDataError
  | IClearUsersError
  | IClearWaitingForUsers
  | IClearUserRoleInformation
  | IGetUserRoleInformation
  | IGetUserRoleInformationError
  | IPostResetPasswordError
  | IGetPortals
  | IGetPortalsSuccess
  | IGetPortalsError
  | IPostDistributorSuccess
  | IPostDistributorError
  | IGetUserIdentitySuccess
  | IGetUserIdentityError
  | IClearUserIdentity;
